import React from 'react';

import { type IconProps } from '@atlaskit/icon';
import { AtlasIcon as LegacyAtlasIcon } from '@atlaskit/legacy-custom-icons';
import { AtlasIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

const AtlasLogoIcon = (props: IconProps) =>
	fg('platform-visual-refresh-icons') ? (
		<AtlasIcon appearance="brand" {...props} />
	) : (
		<LegacyAtlasIcon primaryColor={token('color.text.information')} {...props} />
	);

export default AtlasLogoIcon;
